import React, {useEffect} from "react";

import {Greetings} from '@/components/Greetings/Greetings'
import {AboutUs} from '@/components/AboutUs'
import {MembersListContainer} from "@/features/members";
import {useBodyClass} from "@/hooks";
import classes from "./Home.module.scss";

export const Home = () => {useBodyClass(classes.homePage);
    return (
        <>
            <Greetings/>
            <MembersListContainer/>
            <AboutUs/>
        </>
    )
}
